import http from "@/services/http";

/**
 * Lista as alergias já registradas de um paciente (tabela patient_allergies).
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>} lista de patient_allergies (`{ id, allergen, reaction, severity, ... }`)
 */
export async function getAllergiesByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-allergies/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Catálogo de alergias (referência) — alimenta o select + "Outro".
 * @returns {Promise<Array<{id:number, name:string, category:string|null}>>}
 */
export async function getAllergyCatalog() {
  const { data } = await http.get("/api/allergy-catalog");
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Adiciona uma ou várias alergias de uma vez ao paciente.
 *
 * @param {number|string} patientId
 * @param {object[]} allergies lista `[{ allergen, reaction?, severity?, notes? }]`
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function createAllergies(patientId, allergies) {
  return http.post("/api/patient-allergies/create", {
    patient_id: patientId,
    allergies: allergies.map((a) => ({
      allergen: a.allergen,
      allergy_catalog_id: a.allergy_catalog_id || null,
      reaction: a.reaction || null,
      severity: a.severity || null,
      notes: a.notes || null,
    })),
  });
}

/**
 * Remove uma alergia do paciente (soft delete).
 *
 * @param {number} id
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function deleteAllergy(id) {
  return http.delete(`/api/patient-allergies/delete/${id}`);
}
